import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const TermsError = createComponent<OwnProps>('svg', {
  className: '-:h-[120px] -:w-[120px]'
});

const TermsErrorIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <TermsError
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 120"
    fill="none"
    ref={ref}
    {...props}
  >
    <rect width="120" height="120" rx="60" fill="#F4F8FA" />
    <path
      d="M63 85C54.2019 85 38.1263 85 33.9909 85C33.4386 85 33 84.5523 33 84V30C33 29.4477 33.4477 29 34 29H70.5858C70.851 29 71.1054 29.1054 71.2929 29.2929L80.7071 38.7071C80.8946 38.8946 81 39.1414 81 39.4066C81 41.64 81 52.6208 81 61"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M70.6987 29.6558V37.6558C70.6987 38.208 71.1436 38.6558 71.6958 38.6558C73.6667 38.6558 78.0155 38.6558 79.6987 38.6558"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M62.6426 96.9571L79.2934 69.7103C80.0733 68.4342 81.9267 68.4342 82.7066 69.7103L99.3574 96.9571C100.172 98.2898 99.2127 100 97.6508 100H64.3492C62.7873 100 61.8282 98.2898 62.6426 96.9571Z"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M80.916 88.272H81.444C81.66 88.272 81.876 88.08 81.9 87.888L82.596 81.144V78.456C82.596 78.216 82.38 78 82.14 78H80.22C79.98 78 79.764 78.216 79.764 78.456V81.192L80.46 87.888C80.484 88.08 80.7 88.272 80.916 88.272ZM79.5 93.384C79.5 94.296 80.268 95.04 81.156 95.04C82.092 95.04 82.836 94.296 82.836 93.384C82.836 92.448 82.092 91.704 81.156 91.704C80.268 91.704 79.5 92.448 79.5 93.384Z"
      fill="#00AED9"
    />
    <line
      x1="43"
      y1="47"
      x2="70"
      y2="47"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43 62H62"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43 70H54"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43 54H70"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </TermsError>
));

export default TermsErrorIcon;
